// extracted by mini-css-extract-plugin
export default {"addressAction":"i3-z","loading":"j3-z"};